import { cloneDeep } from '../../utils/clone-deep';
import type { IValidMutationData } from './valid-mutation-data';
import type { MutationType } from '@tencent/slide-sdk-pb-model';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { DeepWritable } from 'ts-essentials';
import type { MutationSource } from '../../constants';

export type MaybeError = Error | undefined;
export abstract class BaseMutation<Model, ValidMutationData extends IValidMutationData> {
    public invertible = true;
    public abstract readonly type: MutationType;

    public constructor(protected readonly data: Omit<Readonly<ValidMutationData>, 'type'>) {}

    public toData(): DeepWritable<Omit<Readonly<ValidMutationData>, 'type'>> & { type: MutationType } {
        return Object.assign(cloneDeep(this.data), { type: this.type });
    }

    public clone(data = this.toData()): BaseMutation<Model, ValidMutationData> {
        type BaseMutationConstructor = new (mutationData: typeof data) => BaseMutation<Model, ValidMutationData>;
        return new (this.constructor as BaseMutationConstructor)(data);
    }

    public abstract apply(model: Model): void;
    public abstract invert(model: Model): IValidMutationData[];
    public abstract check(model: Model, source?: MutationSource): MaybeError;
}

export type Mutation = BaseMutation<PresentationDataModel, IValidMutationData>;
